import { useSelector } from "react-redux";
import { RootState } from "../../redux-stores/store";
import { useDispatch } from "react-redux";
import { toggleProfileUpdateModal } from "../../redux-stores/slices/layoutSlice";

const ProfileCompletion: React.FC = () => {

    const influencer = useSelector((state: RootState) => state.influencer.influencer);
    const dispatch = useDispatch();

    const handleUpdateBtnClick = () => {
        dispatch(toggleProfileUpdateModal(true));
    }

    return (
        <div className="card rounded-4 shadow-none border-0 w-100 mb-3">
            <div className="card-body rounded-4 bg-gray-200 d-flex p-3 flex-column ">
                <div className="d-flex align-items-center w-100 flex-column">
                <div className="progress bg-light-success rounded-l w-100 mb-3 h-8px">
                    <div className="progress-bar bg-success text-start ps-3 color-white" 
                         role="progressbar" style={{"width": `${influencer?.profile_completion}%` }}
                         aria-valuenow={influencer?.profile_completion} aria-valuemin={0} 
                         aria-valuemax={100}>
                    </div>
                </div>
                    <div className="d-flex w-100 mt-auto mb-2">
                        <span className="fw-bolder fs-5 text-dark">Complete Your Profile</span>
                        <span className="text-success fw-bold">
                         ({influencer?.profile_completion}% Completed)
                        </span>
                    </div>
                </div>
                <p>Add your {influencer?.profile_missing} to continue applying to campaigns</p>
                <button className="btn btn-sm btn-primary rounded-4" onClick={handleUpdateBtnClick}>Update Profile</button>
            </div>
        </div>
    )
}

export default ProfileCompletion;